import { motion } from "framer-motion";
import { ShieldCheck, Phone } from "lucide-react";
import { CONTACT, LOGO_WHITE } from "@/data";

export const Hero = () => (
  <section id="top" data-testid="hero-section" className="relative min-h-[100svh] overflow-hidden noise-overlay bg-navy flex items-center">
    {/* subtle radial glow instead of stock photo */}
    <div className="absolute inset-0">
      <div className="absolute -top-1/4 right-0 h-[80vh] w-[80vh] rounded-full bg-gold/10 blur-3xl" />
      <div className="absolute bottom-0 -left-1/4 h-[60vh] w-[60vh] rounded-full bg-white/5 blur-3xl" />
    </div>

    <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10 py-32 w-full">
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.8 }}
        className="font-primary uppercase tracking-[0.3em] text-gold text-xs md:text-sm mb-6"
      >
        {CONTACT.area} · Free Estimates
      </motion.p>

      <motion.img
        src={LOGO_WHITE}
        alt="The Mailbox Brothers LLC"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl h-auto"
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.8 }}
        className="mt-8 max-w-2xl"
      >
        <p className="font-body text-ice/80 text-lg md:text-xl leading-relaxed">
          {CONTACT.name} — mailboxes, light fixtures, garage doors and exterior touch-ups.
          <span className="text-gold font-semibold"> No job is too small.</span>
        </p>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
          <a href="#quote" data-testid="hero-quote-btn" className="font-primary uppercase text-base tracking-wide bg-gold text-navy px-8 py-4 hover:shadow-[5px_5px_0px_#F4F7F6] transition-shadow text-center">
            Book Today
          </a>
          <a href={CONTACT.phoneHref} data-testid="hero-call-btn" className="font-primary uppercase text-base tracking-wide border border-ice/40 text-ice px-6 py-4 flex items-center justify-center gap-2 hover:bg-ice hover:text-navy transition-colors">
            <Phone size={16} /> {CONTACT.phone}
          </a>
        </div>

        <div className="mt-10 inline-flex items-center gap-2 border border-gold/40 rounded-full px-5 py-2.5" data-testid="licensed-badge">
          <ShieldCheck size={18} className="text-gold" />
          <span className="font-primary uppercase tracking-widest text-gold text-xs md:text-sm">Fully Licensed & Insured</span>
        </div>
      </motion.div>
    </div>
  </section>
);
